<template>
<div container--fluid>
    <v-layout>
        <RosterModule></RosterModule>
    </v-layout>
</div>
</template>

<script>
import RosterModule from '@modules/roster/index.vue';

export default {
    name: 'roster',
    components: {
        RosterModule,
    },
    data(){
        return {
            //
        }
    },
};
</script>

<style scoped>

</style>
